import type { PageLoad } from "./$types";

export const load: PageLoad = () => {
  return {
    title: "LLM Engineer's Almanac - Advisor | Modal",
    ogTitle: "LLM Engineer's Almanac - Advisor",
    ogDescription:
      "A simple tool for estimating the throughput and latency of LLM engines",
    ogImageUrl: "https://modal-cdn.com/llm-almanac/preview-image.png",
  };
};
